import React, { useId } from 'react';

/**
 * Uses unique gradient IDs to prevent conflicts when multiple instances are rendered
 * on the same page (e.g., in navigation bars, buttons, and modals simultaneously).
 */
export function UpgradeDiamondIcon(props: React.SVGProps<SVGSVGElement>) {
  const id = useId();

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M6.50001 7C5.94772 7 5.50001 7.44772 5.50001 8C5.50001 8.55228 5.94772 9 6.50001 9H13.5C14.0523 9 14.5 8.55228 14.5 8C14.5 7.44772 14.0523 7 13.5 7H6.50001Z"
        fill={`url(#paint0_linear_${id})`}
      />
      <path
        d="M6.50001 7C5.94772 7 5.50001 7.44772 5.50001 8C5.50001 8.55228 5.94772 9 6.50001 9H13.5C14.0523 9 14.5 8.55228 14.5 8C14.5 7.44772 14.0523 7 13.5 7H6.50001Z"
        fill={`url(#paint1_radial_${id})`}
        fillOpacity="0.4"
      />
      <path
        d="M6.50001 7C5.94772 7 5.50001 7.44772 5.50001 8C5.50001 8.55228 5.94772 9 6.50001 9H13.5C14.0523 9 14.5 8.55228 14.5 8C14.5 7.44772 14.0523 7 13.5 7H6.50001Z"
        fill={`url(#paint2_radial_${id})`}
        fillOpacity="0.8"
      />
      <path
        d="M6.50001 7C5.94772 7 5.50001 7.44772 5.50001 8C5.50001 8.55228 5.94772 9 6.50001 9H13.5C14.0523 9 14.5 8.55228 14.5 8C14.5 7.44772 14.0523 7 13.5 7H6.50001Z"
        fill="black"
        fillOpacity="0.4"
        style={{ mixBlendMode: 'overlay' }}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.90053 2C5.11721 2 4.39027 2.4074 3.98139 3.07553L1.61053 6.94965C1.11096 7.76597 1.18246 8.80898 1.78875 9.54949L8.25909 17.4522C9.1593 18.5517 10.8407 18.5517 11.7409 17.4522L18.2113 9.54949C18.8176 8.80898 18.8891 7.76597 18.3895 6.94965L16.0186 3.07553C15.6097 2.4074 14.8828 2 14.0995 2H5.90053ZM5.6873 4.1195C5.73273 4.04527 5.8135 4 5.90053 4H14.0995C14.1865 4 14.2673 4.04527 14.3127 4.1195L16.6836 7.99362C16.7391 8.08432 16.7311 8.20021 16.6638 8.28249L10.1934 16.1852C10.0934 16.3074 9.9066 16.3074 9.80657 16.1852L3.33624 8.28249C3.26887 8.20021 3.26093 8.08432 3.31644 7.99362L5.6873 4.1195Z"
        fill={`url(#paint3_linear_${id})`}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.90053 2C5.11721 2 4.39027 2.4074 3.98139 3.07553L1.61053 6.94965C1.11096 7.76597 1.18246 8.80898 1.78875 9.54949L8.25909 17.4522C9.1593 18.5517 10.8407 18.5517 11.7409 17.4522L18.2113 9.54949C18.8176 8.80898 18.8891 7.76597 18.3895 6.94965L16.0186 3.07553C15.6097 2.4074 14.8828 2 14.0995 2H5.90053ZM5.6873 4.1195C5.73273 4.04527 5.8135 4 5.90053 4H14.0995C14.1865 4 14.2673 4.04527 14.3127 4.1195L16.6836 7.99362C16.7391 8.08432 16.7311 8.20021 16.6638 8.28249L10.1934 16.1852C10.0934 16.3074 9.9066 16.3074 9.80657 16.1852L3.33624 8.28249C3.26887 8.20021 3.26093 8.08432 3.31644 7.99362L5.6873 4.1195Z"
        fill={`url(#paint4_radial_${id})`}
        fillOpacity="0.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.90053 2C5.11721 2 4.39027 2.4074 3.98139 3.07553L1.61053 6.94965C1.11096 7.76597 1.18246 8.80898 1.78875 9.54949L8.25909 17.4522C9.1593 18.5517 10.8407 18.5517 11.7409 17.4522L18.2113 9.54949C18.8176 8.80898 18.8891 7.76597 18.3895 6.94965L16.0186 3.07553C15.6097 2.4074 14.8828 2 14.0995 2H5.90053ZM5.6873 4.1195C5.73273 4.04527 5.8135 4 5.90053 4H14.0995C14.1865 4 14.2673 4.04527 14.3127 4.1195L16.6836 7.99362C16.7391 8.08432 16.7311 8.20021 16.6638 8.28249L10.1934 16.1852C10.0934 16.3074 9.9066 16.3074 9.80657 16.1852L3.33624 8.28249C3.26887 8.20021 3.26093 8.08432 3.31644 7.99362L5.6873 4.1195Z"
        fill={`url(#paint5_radial_${id})`}
        fillOpacity="0.8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.90053 2C5.11721 2 4.39027 2.4074 3.98139 3.07553L1.61053 6.94965C1.11096 7.76597 1.18246 8.80898 1.78875 9.54949L8.25909 17.4522C9.1593 18.5517 10.8407 18.5517 11.7409 17.4522L18.2113 9.54949C18.8176 8.80898 18.8891 7.76597 18.3895 6.94965L16.0186 3.07553C15.6097 2.4074 14.8828 2 14.0995 2H5.90053ZM5.6873 4.1195C5.73273 4.04527 5.8135 4 5.90053 4H14.0995C14.1865 4 14.2673 4.04527 14.3127 4.1195L16.6836 7.99362C16.7391 8.08432 16.7311 8.20021 16.6638 8.28249L10.1934 16.1852C10.0934 16.3074 9.9066 16.3074 9.80657 16.1852L3.33624 8.28249C3.26887 8.20021 3.26093 8.08432 3.31644 7.99362L5.6873 4.1195Z"
        fill="black"
        fillOpacity="0.4"
        style={{ mixBlendMode: 'overlay' }}
      />
      <defs>
        <linearGradient id={`paint0_linear_${id}`} x1="18.6675" y1="18.2768" x2="-1.49373" y2="13.3505" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FFA82F" />
          <stop offset="1" stopColor="#FF795B" />
        </linearGradient>
        <radialGradient
          id={`paint1_radial_${id}`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0.189618 20.6021) scale(26.4725 15.8837)"
        >
          <stop stopColor="#FF1A96" />
          <stop offset="0.841762" stopColor="#FA00FF" stopOpacity="0.0634006" />
          <stop offset="1" stopColor="#FA00FF" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id={`paint2_radial_${id}`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(16.0731 -0.325263) rotate(124.643) scale(18.9013 19.4084)"
        >
          <stop stopColor="#FFE600" />
          <stop offset="1" stopColor="#FF9500" stopOpacity="0" />
        </radialGradient>
        <linearGradient id={`paint3_linear_${id}`} x1="18.6675" y1="18.2768" x2="-1.49373" y2="13.3505" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FFA82F" />
          <stop offset="1" stopColor="#FF795B" />
        </linearGradient>
        <radialGradient
          id={`paint4_radial_${id}`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0.189618 20.6021) scale(26.4725 15.8837)"
        >
          <stop stopColor="#FF1A96" />
          <stop offset="0.841762" stopColor="#FA00FF" stopOpacity="0.0634006" />
          <stop offset="1" stopColor="#FA00FF" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id={`paint5_radial_${id}`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(16.0731 -0.325263) rotate(124.643) scale(18.9013 19.4084)"
        >
          <stop stopColor="#FFE600" />
          <stop offset="1" stopColor="#FF9500" stopOpacity="0" />
        </radialGradient>
      </defs>
    </svg>
  );
}
